import React, { useEffect, useState } from "react";
import api from "../../utils/Url";
import Card from "@mui/material/Card";
import {
  Box,
  Divider,
  Grid,
  Typography,
  Autocomplete,
  TextField,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getId } from "../../utils/Constant";
import CustomLabel from "../../CustomLable";
import Languages from "../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../TranslateTextField";
import { getISTDate } from "../../utils/Constant";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function CreateDeviceInstall() {
  const { t } = useTranslation();
  const Userid = getId();
  let navigate = useNavigate();
  const location = useLocation();
  const [lang, setLang] = useState<Language>("en");
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });
  //const [option, setOption] = useState<any>([]);
  const [taxOptions, setTaxOptions] = useState<any>([]);
  const [brandOptions, setBrandOptions] = useState<any>([]);
  const [employeeOptions, setemployeeOptions] = useState<any>([]);
  const [itemCategoryOptions, setitemCategoryOptions] = useState<any>([]);
  const [unitOptions, setUnitOptions] = useState<any>([]);
  const [itemgroupOptions, setitemgroupOptions] = useState<any>([]);
  const { defaultValuestime } = getISTDate();
  const [Option, setOption] = useState([
    { value: "-1", label: t("text.SelectZone") },
  ]);
  const [taxOption, setTaxOption] = useState([
    { value: "-1", label: t("text.SelectWard") },
  ]);
  const [polenoOption, setPolenoOption] = useState([
    { value: "-1", label: t("text.SelectPlole") },
  ]);
  const [poleOption, setpoleOption] = useState([
    { value: "-1", label: t("text.SelectPole") },
  ]);


  const [zones, setZones] = useState<any>([]);


  const [isPoleData, setPoleData] = useState<any>([]);

  const [isShow, setIsShow] = useState(false);

  const [selectedLeft, setSelectedLeft] = useState<any>([]);
  const [selectedRight, setSelectedRight] = useState<any>([]);

  // console.log('selectedLeft',selectedLeft)

  // Handle individual checkbox selection for Left Pole
  const handleLeftSelect = (poleInstChildId: any, checked: any) => {
    if (checked) {
      setSelectedLeft((prev: any) => [...prev, poleInstChildId]);
    } else {
      setSelectedLeft((prev: any) => prev.filter((item: any) => item !== poleInstChildId));
    }
  };

  // Handle individual checkbox selection for Right Pole
  const handleRightSelect = (poleInstChildId: any, checked: any) => {
    if (checked) {
      setSelectedRight((prev: any) => [...prev, poleInstChildId]);
    } else {
      setSelectedRight((prev: any) => prev.filter((item: any) => item !== poleInstChildId));
    }
  };

  // Handle "Select All" for Left Pole
  const handleSelectAllLeft = (checked: any) => {
    if (checked) {
      setSelectedLeft(zones[0]?.deviveLeft.map((item: any) => item.poleInstChildId));
    } else {
      setSelectedLeft([]);
    }
  };

  // Handle "Select All" for Right Pole
  const handleSelectAllRight = (checked: any) => {
    if (checked) {
      setSelectedRight(zones[0]?.deviveRight.map((item: any) => item.poleInstChildId));
    } else {
      setSelectedRight([]);
    }
  };





  useEffect(() => {
    //GetitemCategoryData();
    //GetEmployeeData();
    // fetchZonesData();
    // GetItemTypeData();
    //GetTaxData();
    //GetBrandData();
    // GetUnitData();
    //GetItemGroupData();
    // getpolenoData();
    //getPoleData();
    // getTaxData();
    getSupliar();
    GetDataByPoleId();
    // GetLeftRight();
  }, []);
  // }, [isLoading]);  SelectEmployeeName



  const GetDataByPoleId = async () => {
    const collectData = {
      "deviceId": -1,
      "deviceNo": "",
      "simNo": "",
      "simContactNo": "",
      "relayNo": "",
      "zoneId": -1,
      "wardId": -1,
      "poleId": -1
    };
    const response = await api.post(`DeviceInstallation/GetDeviceInstallation`, collectData);
    const data = response.data.data;

    setPoleData(data);

    // const left =
    //   data[0].leftchilddata.map((item: any) => item.leftRightChildId) || [];


    // const Right =
    //   data[0].rightchilddata.map((item: any) => item.leftRightChildId) || [];


    //   formik.setFieldValue('leftchilddata', data[0].leftchilddata);

    //   formik.setFieldValue('rightchilddata', data[0].rightchilddata);


    // //console.log('left',left)
    // setSelectedLeft(left);
    // setSelectedRight(Right);

  }


  const GetLeftRight = async (poleChildId: any) => {
    const collectData = {
      "poleId": poleChildId
    };
    const response = await api.post(`DeviceInstallation/GetLeftRightPole`, collectData);
    const data = response.data.data;
    setZones(data)

  }
  const GetItemGroupData = async () => {
    const collectData = {
      groupid: -1,
    };
    const response = await api.post(`ItemGroup/GetItemGroup`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["group_name"],
        value: data[index]["groupid"],
      });
    }
    setitemgroupOptions([{ value: "-1", label: t("text.selectGroup") }, ...arr]);
  };

  const GetItemTypeData = async () => {
    const collectData = {
      itemTypeMasterId: -1,
    };
    const response = await api.post(`ItemType/GetItemTypeMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemType"],
        value: data[index]["itemTypeMasterId"],
      });
    }
    setOption([{ value: "-1", label: t("text.selectitemTypeId") }, ...arr]);
  };


  const GetitemCategoryData = async () => {
    const collectData = {
      itemCategoryId: -1,
    };
    const response = await api.post(`ItemCategory/GetItemCategoryMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemCategory"],
        value: data[index]["itemCategoryId"],
      });
    }
    setitemCategoryOptions([{ value: "-1", label: t("text.selectItemCategory") }, ...arr]);
  };

  const handleConversionChange = (params: any, text: string) => {
    formik.setFieldValue(params, text);
  };


  const GetTaxData = async () => {
    const collectData = {
      taxId: -1,
    };
    const response = await api.post(`TaxMaster/GetTaxMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["taxName"],
        value: data[index]["taxId"],
      });
    }
    setTaxOptions([{ value: "-1", label: t("text.tax") }, ...arr]);
  };

  const GetBrandData = async () => {
    const collectData = {
      brandID: -1,
    };
    const response = await api.post(`BrandMaster/GetBrandmaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["brandName"],
        value: data[index]["brandID"],
      });
    }
    setBrandOptions([{ value: "-1", label: t("text.brandName") }, ...arr]);
  };



  const GetUnitData = async () => {
    const collectData = {
      unitId: -1,
    };
    const response = await api.post(`UnitMaster/GetUnitMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["unitName"],
        value: data[index]["unitId"],
      });
    }
    setUnitOptions([{ value: "-1", label: t("text.selectUnit") }, ...arr]);
  };

  const getSupliar = async () => {
    const collectData = {
      zoneID: -1,
      user_ID: "",
    };
    const res = await api.post(`Zone/GetZonemaster`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.zoneName,
        value: item.zoneID,
      })) || [];

    setOption(arr);
  };
  const getTaxData = async (id: any) => {
    const collectData = {
      areaID: -1,
      zoneID: id,
    };
    const res = await api.post(`AreaWardMaster/GetAreaWardMaster`, collectData);
    const arr =
      res?.data?.data?.map((item: any) => ({
        label: item.areaName,
        value: item.areaID,
      })) || [];

    setTaxOption(arr);
  };

  const getPoleData = async (wardId: any) => {
    const collectData = {
      poleInstId: -1,
      zoneId: -1,
      wardId: wardId,
    };
    const response = await api.post(`PoleInstallation/GetPoleNoZoneWardWise`, collectData);
    const data = response.data.data;
    const arr = data.map((pole: any) => ({
      label: pole.poleno,
      value: pole.poleInstChildId,
    }));
    setpoleOption(arr);
  };
  // const getpolenoData = async () => {
  //   const collectData = {
  //     "poleInstId": -1,
  //     "zoneId": -1,
  //     "wardId": -1,
  //     "show": true,
  //     "exportOption": ""
  //   };
  //   const res = await api.post(`PoleInstallation/GetPoleInstallation`, collectData);
  //   const arr =
  //     res?.data?.data?.map((item: any) => ({
  //      // label: item.areaName,
  //      // value: item.areaID,
  //     })) || [];

  //     setPolenoOption(arr);
  // };


  const validationSchema = Yup.object().shape({
    deviceName: Yup.string()
      .required(t("Device Name is required")),
    deviceNo: Yup.string()
      .required(t("Device No is required")),
    simNo: Yup.string()
      .required(t("Sim No is required")),
    simContactNo: Yup.string()
      .required(t("Sim Conct No is required")),
    relayNo: Yup.string()
      .required(t("Relay is required")),
    zoneName: Yup.string()
      .required(t("Zone name is required")),
    wardName: Yup.string()
      .required(t("Ward Name is required")),
    poleNo: Yup.string()
      .required(t("Pole No is required")),

  });

  const formik: any = useFormik({
    initialValues: {
      "deviceId": -1,
      "deviceName": "",
      "deviceNo": "",
      "simNo": "",
      "simContactNo": "",
      "relayNo": "",
      "deviceInstDate": new Date().toISOString().slice(0, 10),
      "zoneId": 0,
      "wardId": 0,
      "poleId": 0,
      "isActive": false,
      "isOnOff": false,
      "noOfLight": "",
      "createdBy": Userid,
      "updatedBy": "",
      "createdOn": new Date().toISOString().slice(0, 10),
      "updatedOn": new Date().toISOString().slice(0, 10),
      "zoneName": "",
      "wardName": "",
      "poleNo": "",
      "leftchilddata": [],
      "rightchilddata": []

    },

    validationSchema: validationSchema,
    onSubmit: async (values: any) => {




      const LeftChild: any =
        selectedLeft?.map((item: any) => ({
          "childId": -1,
          "deviceId": -1,
          "type": "Left",
          leftRightChildId: item || 0,
          leftRightPoleNo: "",
        })) || [];

      values.leftchilddata = LeftChild




      const RightChild: any =
        selectedRight?.map((item: any) => ({
          "childId": -1,
          "deviceId": -1,
          "type": "Right",
          leftRightChildId: item || 0,
          leftRightPoleNo: "",
        })) || [];

      values.rightchilddata = RightChild






      const response = await api.post("DeviceInstallation/AddUpdateDeviceInstallation", values);
      if (response.data.isSuccess) {
        formik.resetForm();
        // fetchZonesData();
        setTimeout(() => {

          toast.success(response.data.mesg);
        }, 200);
        navigate("/installation/DeviceInstallMaster")
        // setEditId(-1);
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const back = useNavigate();

  return (
    <>
      <Card
        style={{
          width: "100%",
          backgroundColor: "lightgreen",
          border: ".5px solid #2B4593",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            // backgroundColor:"lightseagreen"
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Grid item xs={12} container spacing={2}>
            <Grid item lg={2} md={2} xs={2} marginTop={2}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{




                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Grid>
            <Grid item lg={7} md={7} xs={7} alignItems="center" justifyContent="center">
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ padding: "20px" }}
                align="center"
              >
                {t("text.CreateDeviceMaster")}
              </Typography>
            </Grid>

            <Grid item lg={3} md={3} xs={3} marginTop={3}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l: any) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>

          <Divider />

          <Box height={10} />
          <form onSubmit={formik.handleSubmit}>
            {/* <Grid container spacing={2}> */}
            {/* First Row */}
            <Grid container item xs={12} spacing={2}>


              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={Option}
                  //   value={
                  //     Option.find(
                  //       (option: any) => option.value === formik.values.stateId
                  //     ) || null
                  //   }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    formik.setFieldValue("zoneId", newValue?.value);
                    formik.setFieldValue("zoneName", newValue?.label);
                    getTaxData(newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectZone")}
                          required={true}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.zoneName && formik.errors.zoneName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.zoneName}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={taxOption}
                  //   value={
                  //     Option.find(
                  //       (option: any) => option.value === formik.values.stateId
                  //     ) || null
                  //   }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    formik.setFieldValue("wardId", newValue?.value);
                    formik.setFieldValue("wardName", newValue?.label);
                    getPoleData(newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectWard")}
                          required={false}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.wardName && formik.errors.wardName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.wardName}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={poleOption}
                  //   value={
                  //     Option.find(
                  //       (option: any) => option.value === formik.values.stateId
                  //     ) || null
                  //   }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    formik.setFieldValue("poleId", newValue?.value);
                    formik.setFieldValue("poleNo", newValue?.label);

                    setIsShow(true);
                    GetLeftRight(newValue?.value)


                    const rowdata = isPoleData.find(
                      (opt: any) => opt.poleId === newValue?.value
                    );

                   // console.log('rowdata',rowdata)
                    if (rowdata) {
                      const left =
                        rowdata?.leftchilddata.map((item: any) => item.leftRightChildId) || [];


                      const Right =
                        rowdata?.rightchilddata.map((item: any) => item.leftRightChildId) || [];


                      
                      setSelectedLeft(left);
                      setSelectedRight(Right);

                    }

                    

                    //GetDataByPoleId(newValue?.value)

                   
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectPole")}
                          required={false}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.poleNo && formik.errors.poleNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.poleNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.devivename")}
                  value={formik.values.deviceName}
                  onChangeText={(text) => handleConversionChange("deviceName", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.deviceName && formik.errors.deviceName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.deviceName}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.deviceno")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="deviceNo"
                  id="deviceNo"
                  value={formik.values.deviceNo}
                  placeholder={t("text.deviceno")}
                  onChange={formik.handleChange}
                />
                {formik.touched.deviceNo && formik.errors.deviceNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.deviceNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.simno")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="simNo"
                  id="simNo"
                  value={formik.values.simNo}
                  placeholder={t("text.deviceno")}
                  onChange={formik.handleChange}
                />
                {formik.touched.simNo && formik.errors.simNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.simNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.simContactNo")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="simContactNo"
                  id="simContactNo"
                  value={formik.values.simContactNo}
                  placeholder={t("text.simContactNo")}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.relayNo")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="relayNo"
                  id="relayNo"
                  value={formik.values.relayNo}
                  placeholder={t("text.relayNo")}
                  onChange={formik.handleChange}
                />
                {formik.touched.relayNo && formik.errors.relayNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.relayNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="deviceInstDate"
                  name="deviceInstDate"
                  label={<CustomLabel text={t("text.deviceInstDate")} required={false} />}
                  value={formik.values.deviceInstDate}
                  placeholder={t("text.deviceInstDate")}
                  size="small"
                  fullWidth
                  type="date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.nooflight")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="noOfLight"
                  id="noOfLight"
                  value={formik.values.noOfLight}
                  placeholder={t("text.nooflight")}
                  onChange={(e: any) => formik.setFieldValue("noOfLight", e.target.value.toString())}
                />
                {/* {formik.touched.noOfLight && formik.errors.noOfLight ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.noOfLight}
                  </div>
                ) : null} */}
              </Grid>


              <Grid item lg={3} xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formik.values.isActive}
                        onChange={formik.handleChange}
                        name="isActive"
                      />
                    }
                    label="Is Active"
                  />
                </FormGroup>
              </Grid>
              <Grid item lg={3} xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formik.values.isOnOff}
                        onChange={formik.handleChange}
                        name="isOnOff"
                      />
                    }
                    label="Is On Off"
                  />
                </FormGroup>
              </Grid>





              <Grid item lg={12} md={12} xs={12}>
                {isShow && (



                  <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2, marginTop: 2 }}>
                    <Table sx={{ minWidth: 650 }} aria-label="light installation table">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: 'bold',
                              backgroundColor: 'var(--grid-headerBackground)',
                              color: 'var(--grid-headerColor)',
                              borderRight: '2px solid #ddd',
                              padding: '12px 16px',
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={zones[0]?.deviveLeft.every((item: any) => selectedLeft.includes(item.poleInstChildId))}
                                  onChange={(e) => handleSelectAllLeft(e.target.checked)}
                                />
                              }
                              label="Left Pole"
                            />
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: 'bold',
                              backgroundColor: 'var(--grid-headerBackground)',
                              color: 'var(--grid-headerColor)',
                              padding: '12px 16px',
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={zones[0]?.deviveRight.every((item: any) => selectedRight.includes(item.poleInstChildId))}
                                  onChange={(e) => handleSelectAllRight(e.target.checked)}
                                />
                              }
                              label="Right Pole"
                            />
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {zones[0]?.deviveLeft.map((leftItem: any, index: any) => (
                          <TableRow key={index}>
                            {/* Left Pole Column */}
                            <TableCell
                              align="left"
                              sx={{
                                padding: '10px 16px',
                                backgroundColor: 'rgba(0, 128, 255, 0.1)',
                                borderRight: '2px solid #ddd',
                              }}
                            >
                              <Checkbox
                              
                                checked={selectedLeft.includes(leftItem.poleInstChildId)}
                                onChange={(e) => handleLeftSelect(leftItem.poleInstChildId, e.target.checked)}
                              />
                              {leftItem.poleno}
                            </TableCell>

                            {/* Right Pole Column */}
                            {zones[0]?.deviveRight[index] && (
                              <TableCell
                                align="left"
                                sx={{
                                  padding: '10px 16px',
                                  backgroundColor: 'rgba(0, 128, 255, 0.1)',
                                  borderRight: '2px solid #ddd',
                                }}
                              >
                                <Checkbox
                                  checked={selectedRight.includes(zones[0]?.deviveRight[index].poleInstChildId)}
                                  onChange={(e) => handleRightSelect(zones[0]?.deviveRight[index].poleInstChildId, e.target.checked)}
                                />
                                {zones[0]?.deviveRight[index].poleno}
                              </TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>


              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.save")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>


        </Paper>
      </Card>
      <ToastApp />
    </>
  );
};